const SET_DEV = 'SET_DEV';
export const setDev = () => ({
    type: SET_DEV
});
const reducer = (state = false, action) => (action.type === SET_DEV ? !state : state);
export const isDevModeSelector = (state) => state.devMode;
export default reducer;
//# sourceMappingURL=index.js.map